import { TextField, Tooltip, IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import { Tags as API } from '../../../services/API/Tags';
import CloseIcon from '@mui/icons-material/Close';
import Toast from '../../../components/Tools/Toast';

export default function DisciplineForm({onAdd, onClose, onSuccess, onError}){

    const [discipline, setDiscipline] = useState('')
    const [toast, setToast] = useState(false)

    const handleSubmit = e => {
        e.preventDefault();

        let tag = {
            title: discipline,
            type: {id: 'discipline', title: 'Discipline'},
            code: discipline.toLowerCase().replaceAll(' ', ''),
            color: '#6495ED'
        }
        
        API.post(tag)
            .then(r => handleSuccess(tag))
            .catch(e => handleError(tag))

        return setDiscipline('');
    }

    const handleSuccess = (tag) => {
        setToast('success')
        return onAdd ? onAdd(tag) : false;
    }

    const handleError = (tag) => {
        setToast('error')
        return onError ? onError(tag) : false;
    }
    
    return <form onSubmit={e => handleSubmit(e)}>
        <Stack direction='row' alignItems='center'>

            <TextField 
                value={discipline}
                onChange={e => setDiscipline(e.target.value)}
                label='Ajouter des disciplines' 
                size='small'
                inputProps={{maxLength: 100}}
                autoFocus
                required
            />

            <Tooltip title='Fermer' onClick={onClose}>
                <IconButton size='small'>
                    <CloseIcon />
                </IconButton>
            </Tooltip>

        </Stack>

        <Toast
            open={toast ? true : false} 
            severity={toast} 
            duration={2000} 
            onClose={() => setToast(false)}
            message={toast === 'success' ? 
                `Le mot clé a bien été enregistré` : 
                `Un mot clé très similaire a déjà été créé`
            }
        />

    </form>
}


